import Capabilities from '@/components/Tools/Capabilities';

const CapabilitiesPage = () => {
  return (
    <div className="p-6">
      <Capabilities />
    </div>
  );
};

export default CapabilitiesPage;
